export function jcfInit(){

    jcf.setOptions({
        wrapNative: false,
        maxVisibleItems: 7,
        alwaysPreventMouseWheel: true,
        mouseWheelStep: 40
    });

    jcf.replaceAll();
}


// WEBPACK FOOTER //
// ./assets/js/modules/jcf-init.js